import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import { useTranslate } from '@refinedev/core';
import { useTokenContext } from 'contexts/resource/ResourceContext';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import ConfigStyle from 'core/constants/ConfigStyle';

const Notification = ({
  notificationsVisible,
  handleToggleNotifications,
}: any) => {
  const t = useTranslate();
  const { notificationMessages, setNotificationMessages } =
    useTokenContext() as any;
  const [cleared, setCleared] = useState(false);
  const [showReadMsg, setShowReadMsg] = useState(true);

  const messages = (() => {
    if (cleared) return [];
    try {
      return notificationMessages ? JSON.parse(notificationMessages) : [];
    } catch {
      return [];
    }
  })();

  const filteredMessages = showReadMsg
    ? messages
    : messages.filter((msg) => !msg?.read);

  useEffect(() => {
    if (notificationsVisible) {
      setShowReadMsg(true);
    }
  }, [notificationsVisible]);

  useEffect(() => {
    setCleared(false);
  }, [notificationMessages]);

  const handleClear = () => {
    setCleared(true);
    if (typeof setNotificationMessages === 'function') {
      setNotificationMessages('[]');
    }
    if (localStorage.getItem('notifications') !== null) {
      localStorage.removeItem('notifications');
    }
  };
  const handleMsgToggle = () => {
    setShowReadMsg((prev) => !prev);
  };

  function getStatusClassName(status) {
    switch (status) {
      case 'success':
        return ConfigStyle.colors['success-50'];
      case 'failed':
        return ConfigStyle.colors['danger-50'];
      case 'in-progress':
        return ConfigStyle.colors['info-50'];
      case 'started':
        return ConfigStyle.colors['neutral-20'];
      default:
        return '';
    }
  }
  function getStatusBorderColor(status) {
    switch (status) {
      case 'success':
        return ConfigStyle.colors['success-500'];
      case 'failed':
        return ConfigStyle.colors['danger-500'];
      case 'in-progress':
        return ConfigStyle.colors['info-500'];
      case 'started':
        return ConfigStyle.colors['neutral-90'];
      default:
        return 'var(--neutral-300)';
    }
  }
  return notificationsVisible ? (
    <div
      className="fixed top-[64px] right-lg z-30 flex w-screen max-w-max p-lg bg-neutral-10 rounded-lg notification"
      style={{
        boxShadow:
          'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px', // theme-audit-ignore
      }}
    >
      <div className="notification-arrow" />
      <div className="w-screen max-w-md flex-auto overflow-hidden text-sm leading-6 ring-2 ring-neutral-50 bg-gradient-to-r from-neutral-20 to-primary-50">
        <span className="text-neutral-10 bg-primary-400 px-md py-xs rounded-md font-semibold">
          {t('common.all', 'All')}
          <span className="bg-neutral-10 text-neutral-900 px-xs rounded-md ml-xs">
            {filteredMessages.length}
          </span>
        </span>

        <div className="mt-md mb-md">
          <span className="text-neutral-900 text-base">
            {t(
              'pages.socketNotification.readUnreadMsg',
              'Show read & unread messages'
            )}
          </span>
          <Switch defaultChecked onChange={handleMsgToggle} className="mx-sm" />
        </div>

        <div>
          {filteredMessages.length > 0 ? (
            <div id="messages" className="max-h-[60vh] overflow-y-auto">
              {filteredMessages.map((item) => {
                const isSuccess = item.status === 'success';
                const isError = item.status === 'failed';

                return (
                  <div
                    key={item?.id}
                    className="relative flex gap-x-lg p-md mb-md rounded-lg"
                    style={{
                      border: '2px solid',
                      borderColor: getStatusBorderColor(item?.status),
                      backgroundColor: getStatusClassName(item?.status),
                    }}
                  >
                    <div
                      className={`mt-xs flex h-11 w-11 flex-none items-center justify-center group-hover:bg-neutral-10 ${
                        isSuccess ? 'bg-success-100' : ''
                      } ${isError ? 'bg-danger-100' : ''}`}
                    >
                      {isSuccess ? (
                        <CheckCircleOutlined className="text-success-500" />
                      ) : (
                        <CloseCircleOutlined className="text-danger-500" />
                      )}
                    </div>
                    <div>
                      <a href="#" className="font-semibold text-neutral-700">
                        {item?.title}{' '}
                        <span className="text-xs text-neutral-100 animate-pulse">
                          {item?.timestamp}
                        </span>
                        <span className="absolute inset-0" />
                      </a>
                      <p className="mt-xs text-neutral-400">{item?.message}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}

          <div className="grid grid-cols-2 divide-x divide-neutral-50 bg-neutral-30">
            <button
              className="flex items-center justify-center gap-x-sm p-sm font-semibold text-neutral-700 hover:bg-primary-50"
              onClick={handleClear}
            >
              <i className="fa-solid fa-broom" /> Clear
            </button>
            <button
              className="flex items-center justify-center gap-x-sm p-sm font-semibold text-neutral-700 hover:bg-primary-50"
              onClick={handleToggleNotifications}
            >
              <i className="fa-regular fa-circle-xmark" />{' '}
              {notificationsVisible ? 'Close' : 'Show Notifications'}
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Notification;
